import { DataTableColumnHeader } from "components/ui/DataTable";
import { ColumnDef } from "@tanstack/react-table";
import { format } from 'date-fns';
import { cpf } from "utils/formatters";

import { getChecklistInfo } from "../checklListUtils";
import { useState } from "react"
import {ModalChecklistFiles} from '../ModalChecklistFiles';
import { FileSymlink } from 'lucide-react';
import { useCallback } from 'react';

const PRINT_STORAGE_KEY = 'gt-checklist-avulso-print';

export function useColumns() {
  const [isOpen, setIsopen] = useState(false);
  const onPrint = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: any) => {
      e.stopPropagation();
      window.localStorage.setItem(PRINT_STORAGE_KEY, JSON.stringify(data));
      window.open('/checklist/avulsos-print', '_blank');
    },
    []
  );

  const columns: ColumnDef<any>[] = [
    {
      id: "id",
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title="ID"
        />
      ),
      cell: ({ row: { original: data } }) => {
        return data.id;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'status',
      accessorKey: 'status',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Status do Checklist" />
      ),
      cell: ({ row: { original: data } }) => getChecklistInfo(data, 'status'),
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "checklist_user",
      accessorKey: "checklist_user_id",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title="Usuário"
        />
      ),
      cell: ({ row: { original: data } }) => {
        return data?.user?.name || "-"; 
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'tipo',
      accessorKey: 'tipo',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Tipo" />
      ),
      cell: ({ row: { original: data } }) => {
        return getChecklistInfo(data, 'tipo');
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "started_at",
      accessorKey: "started_at",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Início do Checklist" />
      ),
      cell: ({ row: { original: data } }) => {
        return data.started_at
          ? format(new Date(data.started_at), 'dd/MM/yyyy HH:mm')
          : "-";
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: "finished_at",
      accessorKey: "finished_at",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Conclusão do Checklist" />
      ),
      cell: ({ row: { original: data } }) => {
        return data.finished_at
          ? format(new Date(data.finished_at), 'dd/MM/yyyy HH:mm')
          : "-";
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'created_at',
      accessorKey: 'created_at',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Criado em" />
      ),
      cell: ({ row: { original: data } }) => {
        return getChecklistInfo(data, 'criado');
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'tempo',
      accessorKey: 'tempo', 
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Tempo do Checklist" />
      ),
      cell: ({ row: { original: data } }) => {
        return <div className="flex justify-center">{getChecklistInfo(data, 'tempo')}</div>;
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'photos',
      accessorKey: 'photos',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Fotos" />
      ),
      cell: ({ row: { original: data } }) => {
        const info = getChecklistInfo(data, 'infoLinks') as { itens?: any[]; links?: string[] } | string;

        if (!info || typeof info === 'string' || !info.links?.length) {
          return <div className="flex justify-center">-</div>;
        }

        return (
          <div className="flex justify-center">
            <ModalChecklistFiles links={info.links} orderId={data.id} itens={info.itens || []} />
          </div>
        );
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'pdf',
      accessorKey: 'pdf',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Imprimir" />
      ),
      cell: ({ row: { original: data } }) => (
        <div className="flex justify-center">
          <button onClick={(e) => onPrint(e, data)}>
            <FileSymlink />
          </button>
        </div>
      ),
      enableSorting: false,
      enableHiding: true,
    },
  ];

  return { columns };
}
